
import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { ThemeProvider } from '@emotion/react'
import IntlProvider from '@/hooks/intl/IntlProvider'
import { injectWorldReady } from '@paypalcorp/worldready-react'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'
import FullPageSpinner from '../utils/FullPageSpinner'
import {
  selectShowMainPageSpinner,
  selectMainPageRetryFetchName,
  selectMainPageUnexpectedClientError,
} from '@/features/ui/ui-slice'
import { getErrorHandlerData } from 'utils/error/error-handler'
import MainPageContent from './MainPageContent'

/**
 * @param showContentPage Set to true when renderred from ErrorBoundary for unexpected
 *  error exception
 */
function MainPage({ flowName, showContentPage, worldReady, children }) {
  // v1 UI state
  const isSessionExpired = useSelector((state: any) => state.common.isSessionExpired)
  const isRequestBlocked = useSelector((state: any) => state.common.isRequestBlocked)
  const loginUrl = useSelector((state: any) => state.common.loginUrl)

  // v2 UI state
  const mainPageUnexpectedClientError = useSelector(selectMainPageUnexpectedClientError)
  const mainPageRetryFetchName = useSelector(selectMainPageRetryFetchName)

  const { fetchRetried, retryHandler } = useSelector(
    (state: any) => state.ui.fetches[mainPageRetryFetchName] || {},
  )

  const { errorContent } = getErrorHandlerData({
    flowName,
    isSessionExpired,
    isRequestBlocked,
    loginUrl,
    fetchRetried,
    retryHandler,
    retryFetchName: mainPageRetryFetchName,
    unexpectedClientError: mainPageUnexpectedClientError,
  })

  let ContentElement: any = React.Fragment
  let content = children

  if (errorContent) {
    ContentElement = MainPageContent
    content = errorContent
  } else if (showContentPage) {
    ContentElement = MainPageContent
  }

  const showMainPageSpinner = useSelector(selectShowMainPageSpinner)

  return (
    <IntlProvider worldReady={worldReady}>
      <ThemeProvider theme={PAYPAL_THEME}>
        {showMainPageSpinner && <FullPageSpinner mainPage />}
        <ContentElement>{content}</ContentElement>
      </ThemeProvider>
    </IntlProvider>
  )
}

MainPage.propTypes = {
  flowName: PropTypes.string,
  showContentPage: PropTypes.bool,
  worldReady: PropTypes.object,
  children: PropTypes.any,
}

export default injectWorldReady(MainPage)
